export const TESTIMONIAL_LABEL="TESTIMONIAL_LABEL";
export const TESTIMONIAL_DESCRIPTION="TESTIMONIAL_DESCRIPTION";